module.exports = __webpack_public_path__ + "img/n9.d16421e5.jpg";